import {HospitalInformation} from "./hospital-information";
import {MeasurementType} from "../../measurement-models";
import {ReportDeliveryNotification} from "./nurse-settings-section/nurse-settings-section.component";
import {ReportLanguageSettings} from "../report-language-settings";


export const ALL_ECG_WORKFLOWS = [
  "DOCTOR_ANALYSIS_ONLY",
  "TECHNICIAN_ANALYSIS_ONLY",
  "TECHNICIAN_PRE_ANALYSIS"
] as const;
type EcgWorkflowTuple = typeof ALL_ECG_WORKFLOWS;
export type EcgWorkflow = EcgWorkflowTuple[number]; // union type

export const ALL_EXTERNAL_ANALYSIS_TYPES = [
  "CARDIOLOGS",
  "CAS"
] as const;
type ExternalAnalysisTypeTuple = typeof ALL_EXTERNAL_ANALYSIS_TYPES;
export type ExternalAnalysisType = ExternalAnalysisTypeTuple[number];

export interface OperatorHospital {
  name: string;
  id: number;
}

export interface EditedHospital {
  id: number;
  name: string;
  eligibleOperators: OperatorHospital[];
  chains: HospitalChain[];
  patientFormTemplateOptionsByMeasurementType: Map<MeasurementType, string[]>;
  hospitalDetails: HospitalDetails;
}

export interface HospitalDetails {
  hospitalInformation: HospitalInformation;
  operatorHospitals: OperatorHospital[];
  nurse2Fa: boolean;
  nurseReportDeliveryNotification: ReportDeliveryNotification;
  selectedPatientFormTemplates: Map<MeasurementType, string>;
  allowedMeasurementTypes: AllowedHospitalMeasurementTypes;
  reportLanguageSettings: ReportLanguageSettings;
  hospitalChain: HospitalChain | undefined;
  assignSleepTechniciansEnabled: boolean;
  nurseInitiatesWithDeviceSerial: boolean;
  ecgWorkflow: EcgWorkflow;
  externalAnalysisType: ExternalAnalysisType;
}

export interface AllowedHospitalMeasurementTypes {
  types: MeasurementType[];
  homeTypes: MeasurementType[];
}

export interface HospitalChain {
  id: number;
  name: string;
}
